export const EDITOR_TOOLBAR = {
  items: [
    'undo',
    'redo',
    '|',
    'bold',
    'italic',
    'underline',
    '|',
    'numberedList',
    'bulletedList',
    'outdent',
    'indent',
    '|',
    'link',
    'imageInsert',
  ],
};

export const NOTE_EDITOR_CONFIG = {
  items: [
    'undo',
    'redo',
    '|',
    'bold',
    'italic',
    'underline',
    '|',
    'numberedList',
    'bulletedList',
    'outdent',
    'indent',
    'alignment',
    '|',
    'link',
    'imageInsert','|',
    'fontSize',
    'fontColor',
    'fontBackgroundColor',
    'insertTable'
  ],
};
export const EMOJI_REGEX = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;